export default __webpack_public_path__ + "static/media/web-16px.4a5b5c0b.svg";